import { clearAdminSession, clearUserSession, getAuthToken } from "../auth/session";

export const apiCall = async ({
  url,
  method = "GET",
  body = null,
  withoutStringify = false,
  role = "user",
}) => {
  try {
    const token = getAuthToken(role);
    const defaultHeaders = {
      Authorization: `Bearer ${token}`,
    };

    const isFormData = typeof FormData !== "undefined" && body instanceof FormData;
    if (!withoutStringify && !isFormData) {
      defaultHeaders["Content-Type"] = "application/json";
    }

    const options = {
      method,
      headers: defaultHeaders,
    };

    if (body) {
      if (isFormData) {
        options.body = body;
      } else {
        options.body = withoutStringify === true ? body : JSON.stringify(body);
      }
    }

    const baseURL = process.env.REACT_APP_API_URL;
    const response = await fetch(`${baseURL}/${url}`, options);

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();

    // Only clear the session that made this request
    if (data?.logout) {
      if (role === "admin") {
        clearAdminSession();
        window.location.href = "/admin/login";
      } else {
        clearUserSession();
        window.location.href = "/login";
      }
    }

    return data;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};
